import React from 'react';
import { Modal, ModalBody, BackDrop } from './ModalResume.styles';
import Resume from '@/components/ResumeV2/ResumeV2';
import { useAppSelector } from '@/app/hooks';
import { selectIsOpenResume } from '@/reducers/currentPage';

export const ModalResume = () => {
  const isOpen = useAppSelector(selectIsOpenResume);

  return (
    <BackDrop $isOpen={isOpen}>
      <Modal $isOpen={isOpen} $isLoading={false} onClick={(e) => e.stopPropagation()}>
        <ModalBody>
          <Resume />
        </ModalBody>
      </Modal>
    </BackDrop>
  );
};
